import { jsxs as r, jsx as o } from "react/jsx-runtime";
import { InfoOutlined as m } from "@mui/icons-material";
import e from "@mui/joy/FormHelperText";
const i = ({ children: i2, color: t = "danger.500", sx: c = {} }) => r(e, { sx: { color: t, ...c }, children: [o(m, {}), i2] });
export {
  i as FormErrorMessage
};
//# sourceMappingURL=FormErrorMessage.js.map
